function initTelevisionProgramSelects(){
  var tv_field = $('.external-payout-television-program-select2');
  tv_field.select2({
    placeholder: 'Įrašykite pavadinimą',
    minimumInputLength: 2,
    multiple: false,
    width: '100%',
    language: lt,
    ajax: {
      url: "/television_programs.json",
      dataType: 'JSON',
      quietMillis: 300,
      data: function (term) {
        return {
          q: { id_in_or_name_cont: term.term },
        };
      },
      processResults: function(data) {
        return { results: data.television_programs }
      },
      results: function (data) {
        return { results: data.results };
      }
    },
  });
  
  // Initialize default selection
  tv_field.each(function(){
    var program_ids = $(this).data('selected');
    if(!!program_ids){
      fetchProgramSelections($(this), "/television_programs.json", [program_ids])
    }
  });

  function fetchProgramSelections(field, url, params){
    if(params.length > 0){
      var select_field = $(field);
      $.ajax({
        type: 'GET',
        url: url,
        data: {
          q: { id_in: params }
        }
      }).then(function (data) {
        data.television_programs.map(function(el, index){
          var option = new Option(el.text, el.id, true, true);
          select_field.append(option).trigger('change');
        });
      });
    }
  }
}

function initMemberSelects(){
  var member_field = $('.external-payout-member-select2');
  member_field.select2({
    placeholder: 'Įrašykite pavadinimą',
    minimumInputLength: 2,
    multiple: false,
    width: '100%',
    language: lt,
    tags: false,
    ajax: {
      url: "/members.json",
      dataType: 'JSON',
      delay: 150, // Reduced from 300ms to 150ms
      cache: true, // Enable caching of results
      data: function (term) {
        return {
            skip_create: true,
            q: { name_or_id: term.term },
        };
      },
      processResults: function(data) {
        return { results: data.members }
      }
    },
  });

  member_field.each(function(){
    var member_ids = $(this).data('selected');
    if(member_ids){
      fetchMemberSelections($(this), "/members.json", [member_ids])
    }
  });

  function fetchMemberSelections(field, url, params){
    if(params.length > 0){
      var select_field = $(field);
      var targetId = params[0]; // Store the target ID we're looking for
      
      $.ajax({
        type: 'GET',
        url: url,
        data: {
          q: { id_in: params },
          skip_create: true
        },
        cache: true
      }).then(function (data) {
        if (data.members && data.members.length > 0) {
          var member = data.members.find(function(m) {
            return m.id.toString() === targetId.toString();
          });
          
          if (member) {
            var option = new Option(member.text, member.id, true, true);
            select_field.append(option).trigger('change');
          }
        }
      });
    }
  }
}

$(function() {
  initTelevisionProgramSelects();
  initMemberSelects();
});